import { useEffect } from 'react'
import { handleError } from '../../utils/alerts'

export default function useError(error, context, showError = true) {
  useEffect(() => {
    error && showError && handleError(error, context)
  }, [error])
}
